module.exports = __webpack_public_path__ + "media/img/flags/UnitedKingdom-33a79546e65bf38629ec0bf90a0bcc3d.png";